import { alpha } from "@mui/material"
import { blueGrey, lightBlue } from "../../core/palette"
import { makeStyles } from "tss-react/mui"
import { STYLES_BY_SIZE } from "./helpers"
import { SystemMessageSize, SystemMessageVariant } from "./SystemMessage"

export type SystemMessageClasses =
  | "container"
  | "iconContainer"
  | "defaultIcon"
  | "contentContainer"
  | "textContainer"
  | "text"
  | "actionsContainer"

const VARIANT_STYLES = {
  info: {
    container: {
      border: lightBlue[300],
      background: alpha(lightBlue[50], 0.5)
    },
    icon: {
      color: "white",
      background: lightBlue[600]
    }
  },
  default: {
    container: {
      border: blueGrey[100],
      background: alpha(blueGrey[50], 0.5)
    },
    icon: {
      color: lightBlue[700],
      background: lightBlue[100]
    }
  }
}

type StylesProps = { size: SystemMessageSize; variant: SystemMessageVariant }

export const useStyles = makeStyles<StylesProps>()<SystemMessageClasses>(
  ({ spacing }, { size, variant }) => {
    const { container, defaultIcon, contentContainer, textContainer } =
      STYLES_BY_SIZE
    const variantStyles = VARIANT_STYLES[variant]

    return {
      container: {
        padding: spacing(container.padding[size]),
        border: `1px solid ${variantStyles.container.border}`,
        borderRadius: "3px",
        backgroundColor: variantStyles.container.background
      },
      iconContainer: {
        flexShrink: 0
      },
      defaultIcon: {
        width: defaultIcon.width[size],
        height: defaultIcon.width[size],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50px",
        color: variantStyles.icon.color,
        backgroundColor: variantStyles.icon.background
      },
      contentContainer: {
        gap: spacing(contentContainer.gap[size])
      },
      textContainer: {
        gap: spacing(textContainer.gap[size])
      },
      text: {
        /* No base styles — styled externally via outerClasses.text*/
      },
      actionsContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: spacing(4)
      }
    }
  }
)
